// Custom Messages

export const elCustomMessages = {
    "pages": {
        "login": {
            "sighInTitle": "Σύνδεση στο SINETOS",
            "username": "Όνομα χρήστη",
            "email": "email",
            "password": "Κωδικός πρόσβασης",
            "rememberMe": "Θυμήσου με",
            "welcome": "Καλώς ήρθατε",
            "login": "Είσοδος",
        },
        "welcome": {
            "home": "Αρχική",
            "features": "Χαρακτηριστικά",
            "events": "Εκδηλώσεις",
            "pricing": "Τιμολόγηση",
            "title": "Βρείτε ακίνητα στην Ελλάδα και την Κύπρο",
            "login": "Σύνδεση",
            "logout": "Αποσύνδεση",
            "dashboard": "Πίνακας Ελέγχου"
        },
        emailAccount: {
            "sendTestEmailTo": "Αποστολή δοκιμαστικού email",
            "sendTestEmailToTitle": "Αποστολή δοκιμαστικού E-Mail (αποθηκεύσετε τις ρυθμίσεις πρώτα κάνοντας κλικ κουμπί «Αποθήκευση»)."
        },
        portfolio: {
            "upload": "Μεταφόρτωση",
            "download": "Λήψη",
            "approval": "Έγκριση",
            "emailInfo": "Email ενημ.",
            "restrictions": {
                "maxFileSize": "Επιτρεπτό όριο μεγέθους εγγράφων < 2.097.152 KB"
            }
        },
    },
    "common": {
        "cancel": "Ακύρωση",
        "employee": "Υπεύθυνο",
        "user": "Χρήστη",
        "confirmation": "Επιβεβαίωση",
        "delete": "Διαγραφή",
        "settings": "Ρυθμίσεις",
        "actions": "Ενέργειες",
        "languages": "Γλώσσες",
        "logout": "Αποσύνδεση",
        "importResources": "Εισαγωγή λεκτικών",//@
        "execute": "Εκτέλεση",//@
        "clearAll": "Εκκαθάριση εγγραφών",
        "mark": "Επισήμανση",
    },
    "messages": {
        "deleteFile": "Διαγραφή αρχείου.",
        "sendingEmail": "Αποστολή email",
        "createNewUser": "Δημιουργία νέου χρήστη.",
        "clearAllCompleted": "Η εκκαθάριση εγγραφών ολοκληρώθηκε με επιτυχία.",
        "emailSendingSuccessfullyCompleted": "Η αποστολή του email ολοκληρώθηκε με επιτυχία.",
        "editSuccessfullyCompleted": "Η μεταβολή ολοκληρώθηκε με επιτυχία.",
        "uploadSuccessfullyCompleted": "Η μεταφόρτωση ολοκληρώθηκε με επιτυχία.",
        "deleteFileSuccessfullyCompleted": "Η διαγραφή αρχείου ολοκληρώθηκε με επιτυχία."
    }
};

// Kendo Angular Component Messages
export const elComponentMessages = {
    // Grid
    "kendo.grid.groupPanelEmpty": "Σύρετε μια κεφαλίδα στήλης και αποθέστε την εδώ για να ομαδοποιήσετε κατά αυτήν τη στήλη.",
    "kendo.grid.noRecords": "Δεν υπάρχουν διαθέσιμες εγγραφές.",
    "kendo.grid.pagerFirstPage": "Μετάβαση στην πρώτη σελίδα.",
    "kendo.grid.pagerPreviousPage": "Μετάβαση στην προηγούμενη σελίδα.",
    "kendo.grid.pagerNextPage": "Μετάβαση στην επόμενη σελίδα.",
    "kendo.grid.pagerLastPage": "Μετάβαση στην τελευταία σελίδα.",
    "kendo.grid.pagerPage": "Σελίδα",
    "kendo.grid.pagerOf": "από",
    "kendo.grid.pagerItems": "στοιχεία",
    "kendo.grid.pagerItemsPerPage": "στοιχεία ανά σελίδα",
    "kendo.grid.pagerPageNumberInputTitle": "Αριθμός σελίδας",
    "kendo.grid.filter": "Φίλτρο",
    "kendo.grid.filterEqOperator": "Ισούται με",
    "kendo.grid.filterNotEqOperator": "Δεν ισούται με",
    "kendo.grid.filterIsNullOperator": "Είναι κενό",
    "kendo.grid.filterIsNotNullOperator": "Δεν είναι κενό",
    "kendo.grid.filterIsEmptyOperator": "Είναι άδειο",
    "kendo.grid.filterIsNotEmptyOperator": "Δεν είναι άδειο",
    "kendo.grid.filterStartsWithOperator": "Ξεκινά με",
    "kendo.grid.filterContainsOperator": "Περιέχει",
    "kendo.grid.filterNotContainsOperator": "Δεν περιέχει",
    "kendo.grid.filterEndsWithOperator": "Τελειώνει με",
    "kendo.grid.filterGteOperator": "Είναι μεγαλύτερο ή ίσο με",
    "kendo.grid.filterGtOperator": "Είναι μεγαλύτερο από",
    "kendo.grid.filterLteOperator": "Είναι μικρότερο ή ίσο με",
    "kendo.grid.filterLtOperator": "Είναι μικρότερο από",
    "kendo.grid.filterIsTrue": "είναι αληθές",
    "kendo.grid.filterIsFalse": "είναι ψευδές",
    "kendo.grid.filterBooleanAll": "(Όλα)",
    "kendo.grid.filterAfterOrEqualOperator": "Είναι μετά ή ίσο με",
    "kendo.grid.filterAfterOperator": "Είναι μετά",
    "kendo.grid.filterBeforeOperator": "Είναι πριν",
    "kendo.grid.filterBeforeOrEqualOperator": "Είναι πριν ή ίσο με",
    "kendo.grid.filterFilterButton": "Φιλτράρισμα",
    "kendo.grid.filterClearButton": "Καθαρισμός",
    "kendo.grid.filterAndLogic": "Και",
    "kendo.grid.filterOrLogic": "Ή",
    "kendo.grid.filterDateToggle": "Εναλλαγή ημερολογίου",
    "kendo.grid.filterDateToday": "Σήμερα",
    "kendo.grid.filterNumericDecrement": "Μείωση τιμής",
    "kendo.grid.filterNumericIncrement": "Αύξηση τιμής",
    "kendo.grid.loading": "Φόρτωση",
    "kendo.grid.columns": "Στήλες",
    "kendo.grid.lock": "Κλείδωμα",
    "kendo.grid.unlock": "Ξεκλείδωμα",
    "kendo.grid.stick": "Καρφίτσωμα",
    "kendo.grid.unstick": "Ξεκαρφίτσωμα",
    "kendo.grid.setColumnPosition": "Ορισμός θέσης στήλης",
    "kendo.grid.sortAscending": "Ταξινόμηση αύξουσα",
    "kendo.grid.sortDescending": "Ταξινόμηση φθίνουσα",
    "kendo.grid.columnsApply": "Εφαρμογή",
    "kendo.grid.columnsReset": "Επαναφορά",
    "kendo.grid.sortable": "Ταξινομήσιμο",
    "kendo.grid.sortedAscending": "Ταξινομημένο αύξοντα",
    "kendo.grid.sortedDescending": "Ταξινομημένο φθίνοντα",
    "kendo.grid.sortedDefault": "Χωρίς ταξινόμηση",
    "kendo.grid.filterInputLabel": "{columnName} Φίλτρο",
    "kendo.grid.filterMenuTitle": "Μενού φίλτρου {columnName}",
    "kendo.grid.filterMenuOperatorsDropDownLabel": "Λειτουργίες φίλτρου {columnName}",
    "kendo.grid.filterMenuLogicDropDownLabel": "Λογική φίλτρου {columnName}",
    "kendo.grid.columnMenu": "Μενού στήλης {columnName}",
    "kendo.grid.selectionCheckboxLabel": "Επιλογή γραμμής",
    "kendo.grid.selectAllCheckboxLabel": "Επιλογή όλων των γραμμών",
    "kendo.grid.pagerLabel": "Πλοήγηση σελίδας, σελίδα {currentPage} από {totalPages}",
    "kendo.grid.gridLabel": "Πίνακας δεδομένων",
    "kendo.grid.groupCollapse": "Σύμπτυξη ομάδας",
    "kendo.grid.groupExpand": "Ανάπτυξη ομάδας",
    "kendo.grid.detailCollapse": "Σύμπτυξη λεπτομερειών",
    "kendo.grid.detailExpand": "Ανάπτυξη λεπτομερειών",
    "kendo.grid.autosizeThisColumn": "Αυτόματη προσαρμογή αυτής της στήλης",
    "kendo.grid.autosizeAllColumns": "Αυτόματη προσαρμογή όλων των στηλών",
    "kendo.grid.pagerSelectPage": "Επιλογή σελίδας",
    "kendo.grid.topToolbarLabel": "Επάνω γραμμή εργαλείων",
    "kendo.grid.bottomToolbarLabel": "Κάτω γραμμή εργαλείων",
    "kendo.grid.groupPanelLabel": "Πίνακας ομάδας",
    "kendo.grid.dragRowHandleLabel": "Σύρσιμο γραμμής",
    "kendo.grid.selectRowCheckboxLabel": "Επιλογή γραμμής",
    "kendo.grid.selectAllRowsCheckboxLabel": "Επιλογή όλων των γραμμών",
    "kendo.grid.filterCellOperatorLabel": "Λειτουργίες φίλτρου κελιού για {columnName}",
    "kendo.grid.booleanFilterCellLabel": "Κελί φίλτρου boolean για {columnName}",
    "kendo.grid.columnMenuFilterTabTitle": "Φίλτρο",
    "kendo.grid.columnMenuGeneralTabTitle": "Γενικά",
    "kendo.grid.columnMenuColumnsTabTitle": "Στήλες",
    "kendo.grid.groupChipMenuPrevious": "Μετακίνηση ως προηγούμενο",
    "kendo.grid.groupChipMenuNext": "Μετακίνηση ως επόμενο",
    "kendo.grid.pagerInputLabel": "Πληκτρολογήστε αριθμό σελίδας",

    // Filter
    "kendo.filter.addExpression": "Προσθήκη έκφρασης",
    "kendo.filter.addFilter": "Προσθήκη φίλτρου",
    "kendo.filter.addGroup": "Προσθήκη ομάδας",
    "kendo.filter.remove": "Αφαίρεση",
    "kendo.filter.editorDateTodayText": "Σήμερα",
    "kendo.filter.editorDateToggleText": "Εναλλαγή ημερολογίου",
    "kendo.filter.editorNumericDecrement": "Μείωση",
    "kendo.filter.editorNumericIncrement": "Αύξηση",
    "kendo.filter.filterAfterOperator": "Είναι μετά",
    "kendo.filter.filterAfterOrEqualOperator": "Είναι μετά ή ίσο με",
    "kendo.filter.filterAndLogic": "Και",
    "kendo.filter.filterBeforeOperator": "Είναι πριν",
    "kendo.filter.filterBeforeOrEqualOperator": "Είναι πριν ή ίσο με",
    "kendo.filter.filterBooleanAll": "(Όλα)",
    "kendo.filter.filterContainsOperator": "Περιέχει",
    "kendo.filter.filterEndsWithOperator": "Τελειώνει με",
    "kendo.filter.filterEqOperator": "Είναι ίσο με",
    "kendo.filter.filterExpressionFilters": "Φίλτρα",
    "kendo.filter.filterExpressionOperators": "Τελεστές",
    "kendo.filter.filterGtOperator": "Είναι μεγαλύτερο από",
    "kendo.filter.filterGteOperator": "Είναι μεγαλύτερο ή ίσο με",
    "kendo.filter.filterIsEmptyOperator": "Είναι κενό",
    "kendo.filter.filterIsFalse": "Είναι ψευδές",
    "kendo.filter.filterIsTrue": "Είναι αληθές",
    "kendo.filter.filterIsNotEmptyOperator": "Δεν είναι κενό",
    "kendo.filter.filterIsNotNullOperator": "Δεν είναι μηδενικό",
    "kendo.filter.filterIsNullOperator": "Είναι μηδενικό",
    "kendo.filter.filterLtOperator": "Είναι μικρότερο από",
    "kendo.filter.filterLteOperator": "Είναι μικρότερο ή ίσο με",
    "kendo.filter.filterNotContainsOperator": "Δεν περιέχει",
    "kendo.filter.filterNotEqOperator": "Δεν είναι ίσο με",
    "kendo.filter.filterOrLogic": "Ή",
    "kendo.filter.filterStartsWithOperator": "Ξεκινά με",
    "kendo.filter.filterFieldAriaLabel": "πεδίο",
    "kendo.filter.filterOperatorAriaLabel": "τελεστής",
    "kendo.filter.filterValueAriaLabel": "τιμή",
    "kendo.filter.filterAriaLabel": "φίλτρο",
    "kendo.filter.filterToolbarAriaLabel": "ρυθμίσεις φίλτρου",

    // DropDowns
    'kendo.autocomplete.noDataText': 'No data found',
    'kendo.autocomplete.clearTitle': 'Clear',
    'kendo.combobox.noDataText': 'No data found',
    'kendo.combobox.clearTitle': 'Clear',
    'kendo.dropdownlist.noDataText': 'No data found',
    'kendo.dropdownlist.clearTitle': 'Clear',

    // Calendar
    'kendo.calendar.today': 'TODAY',

    // TextBox
    'kendo.textbox.clearTitle': 'Clear',

    // DatePicker
    'kendo.datepicker.today': 'TODAY',
    'kendo.datepicker.toggle': 'Toggle calendar',

    // DateInput
    'kendo.dateinput.increment': 'Increase value',
    'kendo.dateinput.decrement': 'Decrease value',

    // NumericTextBox
    'kendo.numerictextbox.increment': 'Increase value',
    'kendo.numerictextbox.decrement': 'Decrease value',

    // DateTimePicker
    'kendo.datetimepicker.dateTab': 'Date',
    'kendo.datetimepicker.dateTabLabel': 'Date tab',
    'kendo.datetimepicker.timeTab': 'Time',
    'kendo.datetimepicker.timeTabLabel': 'Time tab',
    'kendo.datetimepicker.toggle': 'Toggle popup',
    'kendo.datetimepicker.accept': 'Set',
    'kendo.datetimepicker.acceptLabel': 'Set',
    'kendo.datetimepicker.cancel': 'Cancel',
    'kendo.datetimepicker.cancelLabel': 'Cancel',
    'kendo.datetimepicker.now': 'NOW',
    'kendo.datetimepicker.nowLabel': 'Select now',
    'kendo.datetimepicker.today': 'TODAY',
    'kendo.datetimepicker.prevButtonTitle': 'Navigate to previous view',
    'kendo.datetimepicker.nextButtonTitle': 'Navigate to next view',

    // TimePicker
    'kendo.timepicker.accept': 'Set',
    'kendo.timepicker.acceptLabel': 'Set',
    'kendo.timepicker.cancel': 'Cancel',
    'kendo.timepicker.cancelLabel': 'Cancel',
    'kendo.timepicker.now': 'Now',
    'kendo.timepicker.nowLabel': 'Now',
    'kendo.timepicker.toggle': 'Toggle time list',

    // FileSelect
    'kendo.fileselect.cancel': 'Cancel',
    'kendo.fileselect.clearSelectedFiles': 'Clear',
    'kendo.fileselect.dropFilesHere': 'Drop files here to upload',
    'kendo.fileselect.externalDropFilesHere': 'Drag and drop files here to upload',
    'kendo.fileselect.filesBatchStatus': 'files',
    'kendo.fileselect.filesBatchStatusFailed': 'files failed to upload.',
    'kendo.fileselect.filesBatchStatusUploaded': 'files successfully uploaded.',
    'kendo.fileselect.fileStatusFailed': 'File failed to upload.',
    'kendo.fileselect.fileStatusUploaded': 'File successfully uploaded.',
    'kendo.fileselect.headerStatusPaused': 'Paused',
    'kendo.fileselect.headerStatusUploaded': 'Done',
    'kendo.fileselect.headerStatusUploading': 'Uploading...',
    'kendo.fileselect.invalidFileExtension': 'File type not allowed.',
    'kendo.fileselect.invalidMaxFileSize': 'File size too large.',
    'kendo.fileselect.invalidMinFileSize': 'File size too small.',
    'kendo.fileselect.remove': 'Remove',
    'kendo.fileselect.retry': 'Retry',
    'kendo.fileselect.select': 'Select files...',
    'kendo.fileselect.uploadSelectedFiles': 'Upload files',

    // Scheduler
    "kendo.scheduler.agendaViewTitle": "Agenda",
    "kendo.scheduler.allDay": "all day",
    "kendo.scheduler.allEvents": "All events",
    "kendo.scheduler.calendarToday": "TODAY",
    "kendo.scheduler.cancel": "Cancel",
    "kendo.scheduler.save": "Save",
    "kendo.scheduler.editorEventTitle": "Title",
    "kendo.scheduler.editorEventStart": "Start",
    "kendo.scheduler.editorEventStartTimeZone": "Start Time Zone",
    "kendo.scheduler.editorEventEnd": "End",
    "kendo.scheduler.editorEventEndTimeZone": "End Time Zone",
    "kendo.scheduler.dateHeader": "Date",
    "kendo.scheduler.dayViewTitle": "Day",
    "kendo.scheduler.deleteConfirmation": "Are you sure you want to delete this event?",
    "kendo.scheduler.deleteDialogTitle": "Delete Event",
    "kendo.scheduler.deleteOccurrence": "Delete current occurrence",
    "kendo.scheduler.deleteRecurringConfirmation": "Do you want to delete only this event occurrence or the whole series?",
    "kendo.scheduler.deleteRecurringDialogTitle": "Delete Recurring Item",
    "kendo.scheduler.deleteSeries": "Delete the series",
    "kendo.scheduler.deleteTitle": "Delete",
    "kendo.scheduler.destroy": "Delete",
    "kendo.scheduler.editOccurrence": "Edit current occurrence",
    "kendo.scheduler.editorEventAllDay": "All Day Event",
    "kendo.scheduler.editorEventDescription": "Description",
    "kendo.scheduler.editorEventSeparateTimeZones": "End in different Time Zone",
    "kendo.scheduler.editorEventTimeZone": "Specify Time Zone",
    "kendo.scheduler.editorTitle": "Event",
    "kendo.scheduler.editRecurringConfirmation": "Do you want to edit only this event occurrence or the whole series?",
    "kendo.scheduler.editRecurringDialogTitle": "Edit Recurring Item",
    "kendo.scheduler.editSeries": "Edit the series",
    "kendo.scheduler.eventHeader": "Event",
    "kendo.scheduler.monthViewTitle": "Month",
    "kendo.scheduler.multiDayViewTitle": "Multi-Day",
    "kendo.scheduler.nextTitle": "Next",
    "kendo.scheduler.previousTitle": "Previous",
    "kendo.scheduler.recurrenceEditorDailyInterval": "day(s)",
    "kendo.scheduler.recurrenceEditorDailyRepeatEvery": "Repeat every",
    "kendo.scheduler.recurrenceEditorEndAfter": "After",
    "kendo.scheduler.recurrenceEditorEndLabel": "End",
    "kendo.scheduler.recurrenceEditorEndNever": "Never",
    "kendo.scheduler.recurrenceEditorEndOccurrence": "occurrence(s)",
    "kendo.scheduler.recurrenceEditorEndOn": "On",
    "kendo.scheduler.recurrenceEditorFrequenciesDaily": "Daily",
    "kendo.scheduler.recurrenceEditorFrequenciesMonthly": "Monthly",
    "kendo.scheduler.recurrenceEditorFrequenciesNever": "Never",
    "kendo.scheduler.recurrenceEditorFrequenciesWeekly": "Weekly",
    "kendo.scheduler.recurrenceEditorFrequenciesYearly": "Yearly",
    "kendo.scheduler.recurrenceEditorMonthlyDay": "Day",
    "kendo.scheduler.recurrenceEditorMonthlyInterval": "month(s)",
    "kendo.scheduler.recurrenceEditorMonthlyRepeatEvery": "Repeat every",
    "kendo.scheduler.recurrenceEditorMonthlyRepeatOn": "Repeat on",
    "kendo.scheduler.recurrenceEditorOffsetPositionsFirst": "First",
    "kendo.scheduler.recurrenceEditorOffsetPositionsFourth": "Fourth",
    "kendo.scheduler.recurrenceEditorOffsetPositionsLast": "Last",
    "kendo.scheduler.recurrenceEditorOffsetPositionsSecond": "Second",
    "kendo.scheduler.recurrenceEditorOffsetPositionsThird": "Third",
    "kendo.scheduler.recurrenceEditorRepeat": "Repeat",
    "kendo.scheduler.recurrenceEditorWeekdaysDay": "Day",
    "kendo.scheduler.recurrenceEditorWeekdaysWeekday": "Weekday",
    "kendo.scheduler.recurrenceEditorWeekdaysWeekendday": "Weekend Day",
    "kendo.scheduler.recurrenceEditorWeeklyInterval": "week(s)",
    "kendo.scheduler.recurrenceEditorWeeklyRepeatEvery": "Repeat every",
    "kendo.scheduler.recurrenceEditorWeeklyRepeatOn": "Repeat on",
    "kendo.scheduler.recurrenceEditorYearlyInterval": "year(s)",
    "kendo.scheduler.recurrenceEditorYearlyOf": "of",
    "kendo.scheduler.recurrenceEditorYearlyRepeatEvery": "Repeat every",
    "kendo.scheduler.recurrenceEditorYearlyRepeatOn": "Repeat on",
    "kendo.scheduler.showFullDay": "Show full day",
    "kendo.scheduler.showWorkDay": "Show business hours",
    "kendo.scheduler.timeHeader": "Time",
    "kendo.scheduler.timelineMonthViewTitle": "Timeline Month",
    "kendo.scheduler.timelineViewTitle": "Timeline",
    "kendo.scheduler.timelineWeekViewTitle": "Timeline Week",
    "kendo.scheduler.today": "Today",
    "kendo.scheduler.weekViewTitle": "Week",
    "kendo.scheduler.workWeekViewTitle": "Work Week",

    // RecurrenceEditor
    "kendo.recurrenceeditor.dailyInterval": "day(s)",
    "kendo.recurrenceeditor.dailyRepeatEvery": "Repeat every",
    "kendo.recurrenceeditor.endAfter": "After",
    "kendo.recurrenceeditor.endLabel": "End",
    "kendo.recurrenceeditor.endNever": "Never",
    "kendo.recurrenceeditor.endOccurrence": "occurrence(s)",
    "kendo.recurrenceeditor.endOn": "On",
    "kendo.recurrenceeditor.frequenciesDaily": "Daily",
    "kendo.recurrenceeditor.frequenciesMonthly": "Monthly",
    "kendo.recurrenceeditor.frequenciesNever": "Never",
    "kendo.recurrenceeditor.frequenciesWeekly": "Weekly",
    "kendo.recurrenceeditor.frequenciesYearly": "Yearly",
    "kendo.recurrenceeditor.monthlyDay": "Day",
    "kendo.recurrenceeditor.monthlyInterval": "month(s)",
    "kendo.recurrenceeditor.monthlyRepeatEvery": "Repeat every",
    "kendo.recurrenceeditor.monthlyRepeatOn": "Repeat on",
    "kendo.recurrenceeditor.offsetPositionsFourth": "Fourth",
    "kendo.recurrenceeditor.offsetPositionsLast": "Last",
    "kendo.recurrenceeditor.offsetPositionsSecond": "Second",
    "kendo.recurrenceeditor.offsetPositionsThird": "Third",
    "kendo.recurrenceeditor.repeat": "Repeat",
    "kendo.recurrenceeditor.weekdaysDay": "Day",
    "kendo.recurrenceeditor.weekdaysWeekday": "Weekday",
    "kendo.recurrenceeditor.weekdaysWeekendday": "Weekend Day",
    "kendo.recurrenceeditor.weeklyInterval": "week(s)",
    "kendo.recurrenceeditor.weeklyRepeatEvery": "Repeat every",
    "kendo.recurrenceeditor.weeklyRepeatOn": "Repeat on",
    "kendo.recurrenceeditor.yearlyInterval": "year(s)",
    "kendo.recurrenceeditor.yearlyOf": "of",
    "kendo.recurrenceeditor.yearlyRepeatEvery": "Repeat every",
    "kendo.recurrenceeditor.yearlyRepeatOn": "Repeat on",
};
